module.exports = __webpack_public_path__ + "static/media/minilogo-slot.d0ece68f.png";